module.exports = __webpack_public_path__ + "img/goods-mobile-3.e436d6d8.png";